import { ConfigurationManagerBuilder } from '@inform-appshell/fusion-kit-core';

import type { Configuration } from '../interfaces/Configuration';

const baseUrl = import.meta.env.VITE_BASE_URL ?? '/';

/** Load the runtime config.json served from {origin}{base}config/. */
export async function loadConfiguration(): Promise<Configuration> {
  const manager = await new ConfigurationManagerBuilder()
    .withConfigurationDirectory(window.location.origin + baseUrl + 'config/')
    .withFileToLoad('config.json', 'config')
    .build();

  const config = manager.getContent<Configuration>('config');
  if (!config) {
    throw new Error('Configuration not found');
  }
  return config;
}
